import React, { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import ReceiptsSharePage from "./components/ReceiptsSharePage";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/components/LanguageContext";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import VorherNachher from "@/components/VorherNachher";
import AuditSection from "@/components/AuditSection";
import Prozess from "@/components/Prozess";
import StatsBand from "@/components/StatsBand";
import Packages from "@/components/Packages";
import Branchen from "@/components/Branchen";
import UeberUns from "@/components/UeberUns";
import Faq from "@/components/Faq";
import AdminPage from "@/components/AdminPage";
import DiagonalMarquee from "@/components/DiagonalMarquee";
import CTABand from "@/components/CTABand";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import ScrollProgress from "@/components/ScrollProgress";
import { Impressum, Datenschutz } from "@/pages/Legal";
import "@/App.css";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  componentDidCatch(error) {
    console.error(error);
  }
  render() {
    if (this.state.err) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-dark text-bone">
          <p>Etwas ist schiefgelaufen — bitte laden Sie die Seite neu.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const Home = () => (
  <main>
    <Hero />
    <Marquee />
    <Services />
    <VorherNachher />
    <AuditSection />
    <Prozess />
    <StatsBand />
    <Packages />
    <Branchen />
    <UeberUns />
    <Faq />
    <DiagonalMarquee />
    <CTABand />
    <ContactSection />
  </main>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <LanguageProvider>
      <BrowserRouter>
        <ErrorBoundary>
          <ScrollToTop />
          <Routes>
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/belege/:token" element={<ReceiptsSharePage />} />
            <Route
              path="*"
              element={
                <div className="relative overflow-x-clip bg-dark text-bone">
                  <div className="grain" aria-hidden="true" />
                  <Toaster position="bottom-right" />
                  <ScrollProgress />
                  <Navigation />
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/impressum" element={<Impressum />} />
                    <Route path="/datenschutz" element={<Datenschutz />} />
                  </Routes>
                  <Footer />
                </div>
              }
            />
          </Routes>
        </ErrorBoundary>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
